import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { axiosPrivate } from "../utils/axios";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useAxiosPrivateUpgraded = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Request Interceptor
        const requestIntercept = axiosPrivate.interceptors.request.use(
            (config) => {
                if (!config.headers.Authorization) {
                    config.headers.Authorization = `Bearer ${auth?.accessToken}`;
                }

                return config;
            },
            (error) => Promise.reject(error)
        );

        // Response Interceptor
        const responseIntercept = axiosPrivate.interceptors.response.use(
            (response) => response,
            async (error) => {
                const prevRequest = error?.config;

                console.log("Axios Error:", error);

                if (
                    error?.response?.status === 401 &&
                    prevRequest &&
                    !prevRequest.sent
                ) {
                    prevRequest.sent = true;

                    try {
                        const newAccessToken = await refresh();

                        prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                        return axiosPrivate(prevRequest);
                    } catch (refreshError) {
                        console.error("Refresh Token Failed:", refreshError);

                        // Optional
                        // navigate("/login");

                        return Promise.reject(refreshError);
                    }
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        };
    }, [auth, refresh, navigate]);

    return axiosPrivate;
};

export default useAxiosPrivateUpgraded;